import { AlertTriangle, ArrowRight } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

/** Non-clickable badge for widget header when actions pending */
export function WidgetActionBadge({ count, className = '' }) {
  if (!count || count <= 0) return null;
  return (
    <Badge
      variant="destructive"
      className={`tabular-nums pointer-events-none ${className}`}
      data-testid="widget-action-badge"
    >
      {count}
    </Badge>
  );
}

/** Clickable footer strip — opens Action Centre (stops card navigation) */
export function WidgetActionFooter({ count, onViewActions, label }) {
  if (!count || count <= 0 || !onViewActions) return null;

  const text = label || `${count} need${count === 1 ? 's' : ''} your attention`;

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onViewActions();
      }}
      className="w-full flex items-center justify-between gap-2 mt-3 pt-3 border-t border-gray-100 dark:border-gray-800 text-left text-xs font-medium text-amber-800 dark:text-amber-200 hover:text-amber-900 dark:hover:text-amber-100 transition-colors"
      data-testid="widget-action-footer"
    >
      <span className="inline-flex items-center gap-1.5">
        <AlertTriangle className="h-3.5 w-3.5 shrink-0 text-amber-600" />
        {text}
      </span>
      <span className="inline-flex items-center gap-0.5 text-amber-700 dark:text-amber-300 shrink-0">
        View
        <ArrowRight className="h-3 w-3" />
      </span>
    </button>
  );
}
